export const initialState = {
  quoteColumns: [
    {
      id: 'poDate',
      numeric: false,
      disablePadding: true,
      label: 'PO Date',
      align: 'left',
    },
    {
      id: 'description',
      numeric: false,
      disablePadding: true,
      label: 'Description',
      align: 'left',
    },
    {
      id: 'supplier',
      numeric: false,
      disablePadding: true,
      label: 'Supplier',
      align: 'left',
    },
    {
      id: 'poNumber',
      numeric: false,
      disablePadding: true,
      label: 'PO No.',
      align: 'left',
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: 'Price',
      align: 'left',
    },
    {
      id: 'amountInvoiced',
      numeric: false,
      disablePadding: true,
      label: 'Amount Invoiced',
      align: 'left',
    },
    {
      id: 'supplierRef',
      numeric: false,
      disablePadding: true,
      label: 'Supplier Reference No.',
      align: 'left',
    },
    {
      id: 'paid',
      numeric: false,
      disablePadding: true,
      label: 'Paid',
      align: 'center',
    },
    {
      id: 'delete',
      numeric: false,
      disablePadding: true,
      label: '',
      align: 'center',
    },
  ],
  contributionColumns: [
    {
      id: 'date',
      numeric: false,
      disablePadding: true,
      label: 'Date of Contribution',
      align: 'left',
    },
    {
      id: 'contributor_name',
      numeric: false,
      disablePadding: true,
      label: 'Contributor Name',
      align: 'left',
    },
    {
      id: 'contributor_type',
      numeric: false,
      disablePadding: true,
      label: 'Type',
      align: 'left',
    },
    {
      id: 'notes',
      numeric: false,
      disablePadding: true,
      label: 'Notes',
      align: 'left',
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: 'Price',
      align: 'left',
    },
    {
      id: 'contribution_method',
      numeric: false,
      disablePadding: true,
      label: 'Contribution Method',
      align: 'left',
    },
    {
      id: 'receipt',
      numeric: false,
      disablePadding: true,
      label: 'Receipt No.',
      align: 'left',
    },
    {
      id: 'received',
      numeric: false,
      disablePadding: true,
      label: 'Received',
      align: 'center',
    },
    {
      id: 'delete',
      numeric: false,
      disablePadding: true,
      label: '',
      align: 'center',
    },
  ],
  properties: {
    offset: 0,
    hasMore: false,
    loading: false,
    value: [],
  },
  propertyQuotes: {
    loading: {},
    value: {},
  },
  quotes: {
    loading: false,
    value: {},
    fromFilter: false,
  },
  contributions: {
    deleteLoading: false,
    addLoading: {},
    loading: {},
    error: null,
  },
  quoteFilters: {},
  propertyFilters: {},
  contributorTypes: {
    loading: false,
    value: [],
  },
  //outdated below
  quoteFilter: {
    selectedStatuses: [],
    selectedOrganizations: [],
  },
  quoteSort: {
    orderBy: 'last_modified',
    order: 'desc',
  },
  selectedQuoteProduct: {
    value: {},
  },
  selectedQuote: {
    value: {},
  },
  selectedQuoteItem: {
    value: {},
  },
  statusesCount: {
    value: [],
  },
  quoteAttachments: {
    value: [],
    loading: false,
    updating: false,
  },
  organizations: {
    value: [],
  },
};
